import React from 'react';
import {
  Paper, FormControl, InputLabel, Select, OutlinedInput, MenuItem, Checkbox,
  ListItemText, Box, Chip, Autocomplete, TextField, Button
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const FilterRowMiddle = ({
  searchKeywords,
  setSearchKeywords,
  inputValue,
  setInputValue,
  suggestions,
  selectedDepartments,
  setSelectedDepartments,
  allDepartments,
}) => {
  return (
    <Paper
      elevation={1}
      sx={{ p: 2, width: 1100, display: 'flex', gap: 2, alignItems: 'center' }}
    >
      {/* 1. AUTOCOMPLETE / SEARCH KEYWORD */}
      <Autocomplete
        multiple
        freeSolo
        fullWidth
        options={suggestions || []}
        value={searchKeywords}
        inputValue={inputValue}
        filterSelectedOptions
        isOptionEqualToValue={(option, value) => String(option) === String(value)}
        onChange={(event, newValue, reason) => {
          const normalized = (newValue || []).map((item) => {
            if (typeof item === 'string') return item;
            if (item && typeof item === 'object') {
              return item.inputValue ?? item.title ?? String(item);
            }
            return String(item);
          });
          setSearchKeywords(normalized);
          if (reason === 'selectOption' || reason === 'createOption') {
            setInputValue('');
          }
        }}
        onInputChange={(event, newInputValue, reason) => {
          if (reason === 'reset') return;
          setInputValue(newInputValue);
        }}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              size="small"
              label={option}
              {...getTagProps({ index })}
            />
          ))
        }
        sx={{ flexGrow: 1, minWidth: 650 }}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            label="Search Keywords (Type to search or select multiple tags)"
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <>
                  {params.InputProps.startAdornment}
                  <SearchIcon sx={{ color: 'action.active', mr: 1 }} />
                </>
              ),
            }}
          />
        )}
      />

      {/* 2. DEPARTMENT MULTI-SELECT */}
      <FormControl sx={{ flexGrow: 1, minWidth: 350 }}>
        <InputLabel>Department</InputLabel>
        <Select
          multiple
          value={selectedDepartments}
          onChange={(e) => setSelectedDepartments(e.target.value)}
          input={<OutlinedInput label="Department" />}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((value) => (
                <Chip key={value} label={value} />
              ))}
            </Box>
          )}
        >
          {allDepartments.map((dept) => (
            <MenuItem key={dept} value={dept}>
              <Checkbox checked={selectedDepartments.indexOf(dept) > -1} />
              <ListItemText primary={dept} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Paper>
  );
};

export default FilterRowMiddle;